import { toast } from "react-toastify";
import { ApiEndPoints } from "../ApiEndPoints";
import { createRecord } from "./CommonApiService";
import { t } from "i18next";
import moment from "moment";
import { getCardShortCode } from "../../utils/helper";

export const VerifyCard = async (bodyFormDatas, card, userData) => {
  // const user = {
  //   hotelDetail:{
  //     payment_gateway:1
  //   },
  //   hotel_id: 19
  // };
  const user = userData || JSON.parse(localStorage.getItem("userDetails"));

  // console.log(bodyFormDatas, 3);
  if (user?.hotelDetail?.payment_gateway === 1) {
    const result = await createRecord(
      {...bodyFormDatas,
        hotel_id: user?.hotel_id,
        payment_gateway: user?.hotelDetail?.payment_gateway
      },
      ApiEndPoints.VERIFY_USER_CARD_DETAIL + `?hotel_id=${user?.hotel_id}`
    );
    if (result?.status === 200) {
        if (
            // result.data.result[0]?.card?.securityCode.valid === "Y" &&
            result.data.result[0]?.transaction?.responseCode === "A"
          ) {
            toast.success(t("Card Verify Success"));
            const bodyFormData = {
            user_id: bodyFormDatas?.user_id,
            card_holder_name: card?.card_holder_name,
            card_number: result.data.result[0]?.card?.number,
            expiry_date: moment(`${card?.yyy}-${card?.mm}-01`)
              .endOf("month")
              .format("YYYY-MM-DD"),
            // cvv: card?.cvv,
            token: result.data.result[0]?.card?.token.value,
            card_type: result.data.result[0]?.card?.type,
            hotel_id: user?.hotel_id,
            payment_gateway: user?.hotelDetail?.payment_gateway
          };
          return {
            status: 200,
            bodyFormData,
          }
        } else {
            // setLoading(false);
            toast.error(t("Please check card"));
            return {
              status: false,
              bodyFormData: {},
            }
        }
    } else {
      toast.error(t(result.message));
      return {
        status: false,
        bodyFormData: {},
      }
    }
  } else if(user?.hotelDetail?.payment_gateway === 2) {
    const result = await createRecord(
      {...bodyFormDatas,
        hotel_id: user?.hotel_id,
        payment_gateway: user?.hotelDetail?.payment_gateway
      },
      ApiEndPoints.VERIFY_USER_MX_CARD_DETAIL + `?hotel_id=${user?.hotel_id}`
    );
    if (result?.status === 200 && result?.data?.token) {
     
          toast.success(t("Card Verify Success"));
          const bodyFormData = {
          user_id: bodyFormDatas?.user_id,
          card_holder_name: card?.card_holder_name,
          card_number: String(result.data.last4).padStart(16, "X") ,
          expiry_date: moment(`${card?.yyy}-${card?.mm}-01`)
            .endOf("month")
            .format("YYYY-MM-DD"),
          // cvv: card?.cvv,
          token: result.data?.token,
          card_type: getCardShortCode(result.data?.cardType),
          hotel_id: user?.hotel_id,
          payment_gateway: user?.hotelDetail?.payment_gateway
        };
        return {
          status: 200,
          bodyFormData,
        }
        
  } else {
    toast.error(t(result.message));
    return {
      status: false,
      bodyFormData: {},
      }
    } 
  }
};
